var radToDeg = function radToDeg(rad) {
  return rad * 180 / Math.PI;
};

var rotate = function rotate(v) {
  var angle = radToDeg(Math.atan2(v[1], v[0]));
  return rebaseAngle(angle);
};

var matrix2dParsers = {
  x: 4,
  y: 5,
  translateX: 4,
  translateY: 5,
  scaleX: 0,
  scaleY: 3,
  scale: function scale(v) {
    return (Math.abs(v[0]) + Math.abs(v[3])) / 2;
  },
  rotate: rotate,
  rotateZ: rotate,
  skewX: function skewX(v) {
    return radToDeg(Math.atan(v[1]));
  },
  skewY: function skewY(v) {
    return radToDeg(Math.atan(v[2]));
  },
  skew: function skew(v) {
    return (Math.abs(v[1]) + Math.abs(v[2])) / 2;
  }
};

var rebaseAngle = function rebaseAngle(angle) {
  angle = angle % 360;
  if (angle < 0) angle += 360;
  return angle;
};

var rotateZ = rotate;

var scaleX = function scaleX(v) {
  return Math.sqrt(v[0] * v[0] + v[1] * v[1]);
};

var scaleY = function scaleY(v) {
  return Math.sqrt(v[4] * v[4] + v[5] * v[5]);
};

var matrix3dParsers = {
  x: 12,
  y: 13,
  z: 14,
  translateX: 12,
  translateY: 13,
  translateZ: 14,
  scaleX: scaleX,
  scaleY: scaleY,
  scale: function scale(v) {
    return (scaleX(v) + scaleY(v)) / 2;
  },
  rotateX: function rotateX(v) {
    return rebaseAngle(radToDeg(Math.atan2(v[6], v[5])));
  },
  rotateY: function rotateY(v) {
    return rebaseAngle(radToDeg(Math.atan2(-v[2], v[0])));
  },
  rotateZ: rotateZ,
  rotate: rotateZ,
  skewX: function skewX(v) {
    return radToDeg(Math.atan(v[4]));
  },
  skewY: function skewY(v) {
    return radToDeg(Math.atan(v[1]));
  },
  skew: function skew(v) {
    return (Math.abs(v[1]) + Math.abs(v[4])) / 2;
  }
};

function defaultTransformValue(name) {
  return name.includes("scale") ? 1 : 0;
}

function parseValueFromTransform(transform, name) {
  if (!transform || transform === "none") {
    return defaultTransformValue(name);
  }

  var matrix3dMatch = transform.match(/^matrix3d\(([\t-\r ,-\.0-9e\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+)\)$/);
  var parsers;
  var match;

  if (matrix3dMatch) {
    parsers = matrix3dParsers;
    match = matrix3dMatch;
  } else {
    var matrix2dMatch = transform.match(/^matrix\(([\t-\r ,-\.0-9e\xA0\u1680\u2000-\u200A\u2028\u2029\u202F\u205F\u3000\uFEFF]+)\)$/);
    parsers = matrix2dParsers;
    match = matrix2dMatch;
  }

  if (!match) {
    return defaultTransformValue(name);
  }

  var valueParser = parsers[name];
  var values = match[1].split(",").map(convertTransformToNumber);
  return typeof valueParser === "function" ? valueParser(values) : values[valueParser];
}

var readTransformValue = function readTransformValue(instance, name) {
  var _getComputedStyle = getComputedStyle(instance),
      _getComputedStyle$tra = _getComputedStyle.transform,
      transform = _getComputedStyle$tra === void 0 ? "none" : _getComputedStyle$tra;

  return parseValueFromTransform(transform, name);
};

function convertTransformToNumber(value) {
  return parseFloat(value.trim());
}

export { defaultTransformValue, parseValueFromTransform, readTransformValue };